import React from 'react';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import './Department.css';

const Sales: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Sales Department</h1>
          <p className="department-description">
            Welcome to the Sales Department page. Here you can find sales information, 
            targets, performance metrics, and sales resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About Sales Department</h3>
            <p>
              The Sales Department is responsible for driving revenue growth, managing customer relationships, 
              and achieving sales targets through effective sales strategies and customer service.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Sales Strategy and Planning</li>
              <li>Customer Relationship Management</li>
              <li>Sales Target Management</li>
              <li>Product Promotion</li>
              <li>Sales Training</li>
              <li>Performance Analysis</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For sales-related inquiries, please contact the Sales Department.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Sales;

